// TODO: 调整位置
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { ImagePanelFeatureType } from '@/types';

export interface IImageAdjustModel {
    /** 当前面板类型 */
    currentType: ImagePanelFeatureType | '';
    /** 设置当前面板类型 */
    setCurrentType: (payload: ImagePanelFeatureType | '') => void;
}

// TODO: 当前图片面板里面的消除笔和调色都在使用这个，待确认是否应该拆开
const useImagePanelAdjustModel = create<IImageAdjustModel>()(
    immer((set) => ({
        currentType: '',
        setCurrentType: (payload) =>
            set((state) => {
                state.currentType = payload;
            }),
    })),
);

export { useImagePanelAdjustModel };
export const getImagePanelAdjustModel = () => useImagePanelAdjustModel.getState();
